import React from 'react';
import CreatableSelect from 'react-select/creatable';

const CreatableMulti = ({ value, onChange, options, placeholder, styles, isMulti }) => {
  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'create-option') {
      // Handle the creation of a new option
      const newOption = { value: newValue[newValue.length - 1].value, label: newValue[newValue.length - 1].value };
      onChange([...newValue.slice(0, -1), newOption]);
    } else {
      onChange(newValue);
    }
  };

  return (
    <CreatableSelect
      isMulti={isMulti}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      styles={styles}
    />
  );
};

export default CreatableMulti;